<template>

</template>

<script>
/**
 * IntroFlow
 *
 * Moves the user through the introductory app flow
 * Should be fired the first time the user logs into the app
 * After completing this once, the user should never see it again
 *
 * @component
 */
    export default {
        data() {
            return {

            }
        },
        props: {
            appState: String,
            siloData: Object,
        },
        mounted() {
            window.introflow = this;
        },
        methods: {

        },
    }
</script>

<style lang="scss" scopes>

</style>